import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import { ALLOWED_MASTER_DATA_REFRESH_URL } from '../constants/commonConstants';
import ApplicationDetail from '../services/applicationDetail.service';

const useMasterDataRefresh = (): any => {
  const location = useLocation();
  const appService = ApplicationDetail.instance;
  useEffect((): any => {
    const allowedToUpdate = ALLOWED_MASTER_DATA_REFRESH_URL.some((url: string): boolean => url === location?.pathname);
    if (allowedToUpdate) {
      appService.setIsMasterDataUpdateAllowed(true);
    } else {
      appService.setIsMasterDataUpdateAllowed(false);
    }
  }, [location.pathname]);
};
export default useMasterDataRefresh;
